import * as React from 'react';
import { PromotionLayout } from './components/PromotionLayout';
import { PromotionHeader } from './components/PromotionHeader';
import { usePromotionLayout } from './components/PromotionLayout/hooks';
import { useSelector } from 'react-redux';
import { selectIsSubagentLimitExceed } from '../../selectors/publishTerms';
import { PromotionContent } from './components/PromotionContent';

export interface IPromotionContentProps {
  showMoneySourceWidget: boolean;
  isSubagentLimitExceed: boolean;
  showNoServicesScreen: boolean;
}

export const PromotionContainer = () => {
  const isSubagentLimitExceed = useSelector(selectIsSubagentLimitExceed);
  const { showNoServicesScreen, showMoneySourceWidget } = usePromotionLayout();

  return (
    <div data-testid="promotion">
      <PromotionLayout
        title={<PromotionHeader />}
        content={
          <PromotionContent
            showMoneySourceWidget={showMoneySourceWidget}
            isSubagentLimitExceed={isSubagentLimitExceed}
            showNoServicesScreen={showNoServicesScreen}
          />
        }
      />
    </div>
  );
};
